export { default } from './AdsBrandsMobile';